module.exports = __webpack_public_path__ + "static/img/douyin.df72008.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr/douyin.png
// module id = ljFV
// module chunks = 26